import * as EDIT_TYPE from '@/constants/okr-edit-type'
import * as APPROVAL_STATUS from '@/constants/approval-status'
import * as LOCK_STATUS from '@/constants/lock-status'
export default {
  stateOptions: [
    '顺利',
    '拖延',
    '风险',
    '放弃'
  ],
  nothing: '无',
  list: {
    createObjective: '创建目标',
    createKeyResult: '创建实现路径',
    delete: '删除',
    alignOthers: '对齐他人',
    inviteToAlign: '邀请对齐',
    notAligned: '未对齐',
    align: '对齐',
    collapseComment: '收起',
    performanceTarget: '绩效指标',
    performanceReview: '绩效自评',
    superior: '突破级',
    excellent: '优异级',
    target: '基础级',
    performanceIndicators: '绩效指标',
    placeholder: '请输入考核标准，无法设定标准，可输入“无”',
    superiorPlaceholder: '有绝对重大价值贡献或者重大突破',
    excellentPlaceholder: '在本职工作上优秀，结果超预期',
    targetPlaceholder: '请输入考核标准，无法设定标准，可输入“无”',
    financialTarget: '财务目标'
  },
  review: {
    title: '目标复盘',
    inputReview: '录入复盘内容',
    achievement: '进展与成果',
    achievementPlaceholder: '关键的里程碑达成情况和时间点，哪些超过预期，哪些未达到预期，分析说明其中的原因',
    problem: '决策与问题',
    problemPlaceholder: '遇到的瓶颈、卡点是什么，有什么具体的策略和计划',
    saveSuccessMessage: '目标复盘总结保存成功',
    uploadButton: '上传附件',
    // eslint-disable-next-line no-template-curly-in-string
    uploadMaxSizeWarning: '文件${filename}超过最大尺寸（{maxFileSize}MB）限制',
    uploadMaxNumWarning: '一次只能上传不超过{maxFileNum}个文件',
    attachmentLabel: '附件：',
    placeholder: '请输入'
  },
  overallReview: {
    title: '请填写总体目标复盘'
  },
  toolbar: {
    followSuccessMessage: '关注用户成功',
    unfollowSuccessMessage: '取消关注用户成功',
    approvalStatus: {
      [APPROVAL_STATUS.UNCOMMITTED]: '',
      [APPROVAL_STATUS.WAITING_FOR_APPROVAL]: '审批中，无法新建或编辑',
      [APPROVAL_STATUS.APPROVED]: '',
      [APPROVAL_STATUS.REJECTED]: '审批未通过，请调整后，重新提交',
      undefined: ''
    },
    lockStatus: {
      [LOCK_STATUS.LOCKED]: ' 当前已进入绩效考核阶段，OKR修改功能已关闭。',
      [LOCK_STATUS.UNLOCKED]: '',
      undefined: ''
    },
    publish: {
      publishButton: '提交',
      description: '是否确认提交？',
      notifyAssociated: '发布成功后，通知相关人员',
      followed: '关注我的',
      alignedToPersons: '我对齐的人',
      beAlignedFromPersons: '对齐我的人',
      mentioned: '提及人',
      successMessage: '提交成功。审批通过后，内容正式发布。',
      errorMessage: '提交失败',
      weightErrorMessage: '目标总占比必须等于100/100，请检查设置',
      organizationalSkillsErrorMessage: '未录入组织能力，请录入后，再次提交',
      personalDevelopmentErrorMessage: '未录入个人发展，请录入后，再次提交'
    },
    needAlignHint: '页面如有标记小红点的条目，则需要对齐'
  },
  editDialogTitle: {
    [EDIT_TYPE.CREATE_OBJECTIVE]: '创建目标',
    [EDIT_TYPE.EDIT_OBJECTIVE]: '编辑目标',
    [EDIT_TYPE.CREATE_KEY_RESULT]: '创建实现路径',
    [EDIT_TYPE.EDIT_KEY_RESULT]: '编辑实现路径',
    [EDIT_TYPE.EDIT_PERSONAL_OBJECTIVE]: '个人发展',
    [EDIT_TYPE.EDIT_ORGANIZATIONAL_OBJECTIVE]: '组织能力'
  },
  createObjectiveDialog: {
    successMessage: '目标创建成功'
  },
  editObjectiveDialog: {
    contentPlaceholder: '请输入目标内容',
    superiorPlaceholder: '有绝对重大价值或者重大突破，无法设定标准，可输入“无”',
    excellentPlaceholder: '在本职工作上优秀，结果超预期，无法设定标准，可输入“无”',
    targetPlaceholder: '请输入考核标准，无法设定标准，可输入“无”',
    hideOrNot: '是否隐藏',
    successMessage: '目标保存成功',
    hideOrNotTip: '隐藏后，该指标仅上级、HRBP、HRBP Lead可见',
    whetherIsAboutFinance: '是否为财务目标'
  },
  editKeyResultDialog: {
    contentPlaceholder: '请输入实现路径内容',
    successMessage: '实现路径保存成功',
    targetPlaceholder: '请输入指标内容'
  },
  deleteObjectiveDialog: {
    description: '是否确认删除目标',
    successMessage: '目标删除成功'
  },
  deleteKeyResultDialog: {
    description: '是否确认删除实现路径',
    successMessage: '实现路径删除成功'
  },
  alignedUser: {
    cancelAlignment: '取消对齐'
  },
  weightDialog: {
    successMessage: '目标占比更新成功'
  },
  progressDialog: {
    progressSuccessMessage: '实现路径进度更新成功',
    stateSuccessMessage: '实现路径状态更新成功'
  },
  autoSaveOnBlur: '失去焦点后自动保存',
  notPublishedWarning: {
    title: '当前周期的 OKR 还没有发布，是否确定离开',
    notShowAgain: '不再提示'
  },
  learnBestCase: '查看 OKR 示例',
  formRules: {
    required: {
      objective: '目标内容不能为空',
      keyResult: '实现路径不能为空',
      shared: '内容不能为空'
    }
  },
  cycle: {
    fullYear: '年度目标'
  },
  comment: {
    reply: '回复',
    send: '发送',
    sentMessage: '评论发送成功',
    deletedMessage: '评论删除成功',
    commentPlaceholder: '添加评论',
    replyPlaceholder: '添加回复'
  },
  okrListReview: {
    title: 'OKR 复盘总结',
    placeholder: '请填写 OKR 复盘总结',
    sentMessage: 'OKR 复盘总结发布成功',
    deletedMessage: 'OKR 复盘总结删除成功',
    send: '发布'
  },
  personalObjective: {
    review: '自评',
    teamBuilding: '团队建设',
    talentDevelopment: '人才发展',
    culturalAtmosphere: '文化氛围',
    professionalPrecipitation: '专业沉淀',
    abilityBreakthrough: '能力突破',
    teamBuildingSelfReview: '团队建设',
    talentDevelopmentSelfReview: '人才发展',
    culturalAtmosphereSelfReview: '文化氛围',
    professionalPrecipitationSelfReview: '专业沉淀',
    abilityBreakthroughSelfReview: '能力突破',
    teamBuildingTip1: '根据产品定位与分类，【本职能】的重点工作方向，制定支撑业务的人才策略与配置规划，提高效能',
    teamBuildingTip2: '请从【HC执行情况及整体人才高度】、【关键岗位到位情况】、【团队决策机制及分工】等维度进行描述：',
    talentDevelopmentTip1: '根据业务重点明确关键岗位，提升岗位胜任度',
    talentDevelopmentTip2: '请从【核心人才培养输出（列举出1-3名培养对象）】【IDP执行情况】、【核心人才主动离职率】等维度进行描述：',
    culturalAtmosphereTip1: '认同公司价值观，制定并践行团队原则，助力团队融合和士气提升',
    culturalAtmosphereTip2: '请从【团队原则】【沟通机制（目标传达与对齐）】等维度进行描述：',
    professionalPrecipitationTip1: '通过在项目上的专业输出，为团队沉淀自己负责领域内的知识、方法（论）、流程和体系。',
    professionalPrecipitationTip2: '专业领域持续知识沉淀，如案例沉淀、项目组分享、workdayUGC沉淀、funview分享等',
    professionalPrecipitationTip3: '专业领域方法/方法论贡献',
    professionalPrecipitationTip4: '专业领域流程和体系建设',
    abilityBreakthroughTip1: '识别能力发展要项，并通过在项目上的任务达成或业绩突破，达成能力提升的预期目标（IDP）',
    abilityBreakthroughTip2: '能力优势和能力发展要项选取与团队目标的关联度（目标关联）',
    abilityBreakthroughTip3: '能力要项发展和工作任务选取的匹配度（任务匹配）',
    abilityBreakthroughTip4: '能力发展预期目标（IDP）的达成率（结果达成）',
    placeholder: '请输入'
  },
  titles: {
    input: '录入',
    objectiveTitle: '业绩目标',
    leaderTitle: '组织能力',
    normalTitle: '个人发展',
    review: '总体目标复盘',
    subTitle: '复盘'
  },
  radio: {
    hide: '是',
    not: '否',
    yes: '是',
    no: '否'
  }
}
